<script setup lang="ts">
import { computed } from 'vue'

import type { ReportHeatmapIntensity } from '../../service/tablePresentation'

const props = defineProps<{
  displayValue: string
  accessibilityLabel: string
  intensity: ReportHeatmapIntensity
  ratio: number
}>()

const style = computed(() => ({
  '--report-heatmap-strength': `${Math.round(Math.min(1, Math.max(0, props.ratio)) * 28)}%`,
}))
</script>

<template>
  <span
    class="report-heatmap-cell block my-[calc(-1_*_var(--ui-space-sm))] mx-[calc(-1_*_var(--ui-space-md))] py-sm px-md bg-[color-mix(_in_srgb,_var(--ui-color-primary)_var(--report-heatmap-strength),_transparent_)] border-s-[0.125rem] border-s-transparent"
    :class="`report-heatmap-cell--${intensity}`"
    :style="style"
    :aria-label="accessibilityLabel"
  >
    <span aria-hidden="true">{{ displayValue }}</span>
  </span>
</template>

<style scoped>
.report-heatmap-cell.report-heatmap-cell--medium {
  border-inline-start-color: var(--ui-color-primary);
}
.report-heatmap-cell.report-heatmap-cell--high {
  border-inline-start-color: var(--ui-color-primary);
  font-weight: 600;
}
</style>
